import React from "react";

/**
 * Status badge (§2.6): tinted background + dark text + optional dot.
 * variant: neutral | brand | info | warning | danger | success.
 * Status is shown as badges — never as colored table cells.
 */
function Badge({ variant = "neutral", dot = false, children }) {
  return (
    <span className={`fk-badge fk-badge--${variant}`}>
      {dot ? <span className="fk-badge__dot" /> : null}
      {children}
    </span>
  );
}

export default Badge;
